import { Component, Input, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ApiService } from 'src/app/service/api/api.service';

@Component({
  selector: 'app-header-sceau',
  templateUrl: './header-sceau.component.html',
  styleUrls: ['./header-sceau.component.scss']
})
export class HeaderSceauComponent implements OnInit {

  @Input() sidebarId: string = 'sidebarSceau';

  pendingReclamations: any[] = [];
  pendingReclamationCount = 0;

  // ── Recherche mairie ──────────────────────────────────────────
  id_mairie: string = '';
  mairie_search: string = '';
  mairies_filtrees: any[] = [];
  show_mairie_dropdown = false;

  constructor(public api: ApiService, private swUpdate: SwUpdate) { }

  ngOnInit() {
    const categorie = (this.api.infos?.current_mairie?.categorie || '').toLowerCase();
    const role = (
      this.api.infos?.agent?.role
      || this.api.infos?.token?.token_decoded?.taf_data?.role
      || this.api.infos?.token?.user_connected?.role
      || ''
    ).toLowerCase();

    const is_perception_context = (
      categorie === 'perception'
      || categorie === 'tresor'
      || role.includes('percept')
      || role.includes('tresor')
    );
    const manually_selected = this.api.infos?.mairie_manually_selected;

    if (is_perception_context) {
      this.id_mairie = manually_selected
        ? (this.api.infos.current_mairie?.id_mairie || '')
        : '';
    } else {
      this.id_mairie = this.api.infos.current_mairie?.id_mairie || '';
    }

    this.mairies_filtrees = this.api.infos.les_mairies || [];
    this.refresh_reclamations_badge();
  }

  // ── Recherche mairie ──────────────────────────────────────────
  on_mairie_search() {
    const search = (this.mairie_search || '').toLowerCase().trim();
    this.mairies_filtrees = (this.api.infos.les_mairies || []).filter(
      (m: any) => !search || (m.nom || '').toLowerCase().includes(search)
    );
    this.show_mairie_dropdown = true;
  }

  get_mairie_label(): string {
    if (!this.id_mairie) return '';
    const found = (this.api.infos.les_mairies || []).find(
      (m: any) => String(m.id_mairie) === String(this.id_mairie)
    );
    return found?.nom || '';
  }

  select_mairie(id: any, event: MouseEvent) {
    event.preventDefault();
    this.id_mairie = id ? String(id) : '';
    this.mairie_search = this.id_mairie ? this.get_mairie_label() : '';
    this.show_mairie_dropdown = false;
    this.mairie_change();
  }

  on_blur_mairie() {
    setTimeout(() => {
      this.show_mairie_dropdown = false;
      this.mairie_search = this.id_mairie ? this.get_mairie_label() : '';
      this.mairies_filtrees = this.api.infos.les_mairies || [];
    }, 200);
  }

  async mairie_change() {
    if (!this.id_mairie || this.id_mairie === '') {
      this.api.infos.current_mairie = this.api.infos.les_mairies[0];
      this.api.infos.mairie_manually_selected = false;
      this.api.infos.filtre_toutes_mairies = true;
    } else {
      this.api.infos.current_mairie = (this.api.infos.les_mairies || []).find(
        (one: any) => String(one.id_mairie) === String(this.id_mairie)
      );
      this.api.infos.mairie_manually_selected = true;
      this.api.infos.filtre_toutes_mairies = false;
    }
    await this.api.save_on_local_storage('infos', this.api.infos);
    window.location.reload();
  }

  get cible_role(): string {
    const categorie = (this.api.infos?.current_mairie?.categorie || '').toLowerCase();
    if (categorie === 'mairie' || categorie.includes('mair')) return 'mairie';
    if (categorie === 'perception' || categorie === 'tresor' || categorie.includes('percept')) return 'perception';
    return '';
  }

  refresh_reclamations_badge() {
    if (!this.api.can('/home/reclamation')) {
      this.pendingReclamations = [];
      this.pendingReclamationCount = 0;
      return;
    }
    this.api.taf_post('reclamation/get_notifications', {}, (rep: any) => {
      if (rep?.status) {
        if (this.cible_role === 'mairie') {
          this.pendingReclamationCount = +rep.nb_attente_mairie || 0;
        } else if (this.cible_role === 'perception') {
          this.pendingReclamationCount = +rep.nb_attente_perception || 0;
        } else {
          this.pendingReclamationCount = +rep.total_attente || 0;
        }
      }
    }, () => { });

    const filtres: any = { etat_reclamation: 0 };
    if (this.cible_role) filtres.cible_reclamation = this.cible_role;

    this.api.taf_post_object('reclamation/get_2', filtres, (rep: any) => {
      if (rep?.status && Array.isArray(rep.data)) {
        this.pendingReclamations = rep.data;
      } else {
        this.pendingReclamations = [];
      }
    }, () => { this.pendingReclamations = []; });
  }

  get_titre() {
    const user = this.api.infos.agent;
    switch (user?.id_privilege) {
      case 2: return { titre: user?.prenom + ' ' + (user.nom ?? ''), description: 'Collecteur' };
      case 3: return { titre: user?.prenom + ' ' + (user.nom ?? ''), description: 'Régisseur' };
      case 4: return { titre: user?.prenom + ' ' + (user.nom ?? ''), description: 'Conseil Municipal' };
      case 5: return { titre: user?.prenom + ' ' + (user.nom ?? ''), description: 'Trésor publique' };
      case 6: return { titre: user?.prenom + ' ' + (user.nom ?? ''), description: 'Recenseur' };
      case 7: return { titre: user?.prenom + ' ' + (user.nom ?? ''), description: 'Administrateur' };
      default: return { titre: '', description: '' };
    }
  }

  checkForUpdates(): void {
    this.swUpdate.checkForUpdate();
  }

  toggleSidebar() {
    this.api.show_sidebar = !this.api.show_sidebar;
    this.api.save_on_local_storage('show_sidebar', this.api.show_sidebar);
  }
}
